import { render, staticRenderFns } from "./OrganisationDropdown.vue?vue&type=template&id=4df2d884&scoped=true&"
import script from "./OrganisationDropdown.vue?vue&type=script&lang=js&"
export * from "./OrganisationDropdown.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationDropdown.vue?vue&type=style&index=0&id=4df2d884&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df2d884",
  null
  
)

export default component.exports